//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { GALLERY_TYPE } from '@galleries/models/galleriesStateModel';
import { ICuralateStore } from '@models/AppState';

const getTypeOfGallery = (state: ICuralateStore) =>
  state.galleries.creation.typeOfGallery;

export const getTypeOfGalleryLabel = createSelector(
  getTypeOfGallery,
  (typeOfGallery) => {
    const isCreatingInstaShop = typeOfGallery === GALLERY_TYPE.INSTASHOP;

    return isCreatingInstaShop ? 'InstaShop' : 'Gallery';
  },
);

export default getTypeOfGalleryLabel;
